import { NavLink, Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "../../../i18n";
import SupportLibraryPage from "./SupportLibraryPage";

const destinations = [
  { path: "/mockups", key: "mockups", icon: "image" },
  { path: "/designs", key: "designs", icon: "collections" },
  { path: "/templates", key: "templates", icon: "dashboard_customize" },
  { path: "/downloads", key: "jobs", icon: "work_history" },
] as const;

export default function SupportModeLayout() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  if (!destinations.some((item) => item.path === pathname))
    return <Navigate to="/mockups" replace />;
  return (
    <div className="min-h-dvh bg-background text-on-surface">
      <a
        href="#support-main"
        className="sr-only focus:not-sr-only focus:block focus:p-4 focus:text-primary"
      >
        {t("operatorAdmin.support.skip")}
      </a>
      <nav
        aria-label={t("operatorAdmin.support.navigation")}
        className="grid grid-cols-2 gap-1 border-b border-outline-variant px-4 py-2 sm:flex sm:px-6"
      >
        {destinations.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex min-h-11 items-center gap-2 rounded-lg px-3 text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 ${isActive ? "bg-primary/10 text-primary" : "text-on-surface-variant hover:bg-surface-container-high"}`
            }
          >
            <span className="material-symbols-outlined shrink-0 text-lg" aria-hidden="true">
              {item.icon}
            </span>
            {t(`operatorAdmin.support.destinations.${item.key}`)}
          </NavLink>
        ))}
      </nav>
      <SupportLibraryPage key={pathname} path={pathname} />
    </div>
  );
}
